module.exports = __webpack_public_path__ + "static/media/personHidden.1395b688.png";